export default "__VITE_ASSET__DYu8h3Js__"